export default "__VITE_ASSET__BYgGzH35__"